import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../../../utils/domain/routingComponents'
import { caperBillingAccessControl } from '../access-control/caperBillingAccess.configuration'

const CaperBillingLandingPage = lazy(() => import('../pages/CaperBillingLandingPage'))
const CaperBillingUploadPage = lazy(() => import('../pages/CaperBillingUploadPage'))
const CaperBillingHistoryPage = lazy(() => import('../pages/CaperBillingHistoryPage'))

export const caperBillingAdminRouter = (
  <DomainRoute route="app-admin-caper-billing" accessControl={caperBillingAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-caper-billing-upload"
        component={CaperBillingUploadPage}
      />
      <DomainRoute
        exact
        route="app-admin-caper-billing-history"
        component={CaperBillingHistoryPage}
      />
      <DomainRoute exact route="app-admin-caper-billing" component={CaperBillingLandingPage} />
      <DomainRedirect toRoute="app-admin-caper-billing" />
    </DashSwitch>
  </DomainRoute>
)
